export function getDetailCustomReportCustomer()
{
    return({
        type:"GET_DETAIL_CUSTOM_REPORT_DATA_CUSTOMER"
    })
}